import * as BABYLON from "babylonjs";
import { GeoPoint } from "./geoPoint";

export class CoordUtils {
    static geoToBabylon(geo: GeoPoint): BABYLON.Vector3 {
        return CoordUtils.ecefToBabylon(geo.toEcefCoords());
    }

    static ecefToBabylon(ecef: BABYLON.Vector3): BABYLON.Vector3 {
        let scale = 1 / GeoPoint.EarthRadius;
        return new BABYLON.Vector3(scale * ecef.y, scale * ecef.z, -scale * ecef.x);
    }

    static babylonToGeo(vector: BABYLON.Vector3): GeoPoint {
        return GeoPoint.fromEcefCoords(CoordUtils.babylonToEcef(vector));
    }

    static babylonToEcef(vector: BABYLON.Vector3): BABYLON.Vector3 {
        let scale = GeoPoint.EarthRadius;
        return new BABYLON.Vector3(-scale * vector.z, scale * vector.x, scale * vector.y);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/core/coordUtils.ts